import React, { createContext, useContext, useState, useRef, useEffect } from "react";
import ApplicationContext from "./ApplicationContext";
import useInterval from "./hooks/useInterval";

interface ReminderContextType {
  reminderStatus: any;
  refreshReminderStatus: () => void;
  stopRemindTimer: () => void,
  reminderCount: number,
  refreshReminderCount: () => void;
}

export const ReminderContext = createContext<ReminderContextType | undefined>(undefined);

export const ReminderProvider = ({ children }: { children: React.ReactNode }) => {
  const appContext = useContext(ApplicationContext);

  const apiRef = useRef(appContext.api);
  const userIdRef = useRef(appContext.user?.id ?? "");

  const [reminderStatus, setReminderStatus] = useState(false);
  const [useCheckReminder, setUseCheckReminder] = useState(false);
  const [reminderCount, setReminderCount] = useState(0);

  useEffect(() => {
    refreshReminderStatus(); //초기 Task Status 확인
    refreshReminderCount(); // 초기 Task 갯수 확인
  }, []);

  useEffect(() => {
    apiRef.current = appContext.api;
    userIdRef.current = appContext.user?.id ?? "";
  }, [appContext.api, appContext.user]);

  // 1분마다 체크
  useInterval(() => {
    if (useCheckReminder) {
      refreshReminderStatus();
    }
  }, useCheckReminder ? 60000 : null);

  const refreshReminderStatus = async () => {
    if (!userIdRef.current) return;
    const result = await apiRef.current.getReminderTaskTime(userIdRef.current);
    //result[0]: reminderStatus, result[1]: reminderTime, result[1]: reminderDueTime

    if (result && result.length > 0) {
      setReminderStatus(result[0]);

      // 최초 리마인더가 존재하면 interval 활성화
      if (result[0] !== '' && !useCheckReminder) {
        setUseCheckReminder(true);
      }

      // 리마인더가 없으면 interval 종료
      if (result[0] === '') {
        setUseCheckReminder(false);
      }
    } else {
      if (useCheckReminder) setUseCheckReminder(false);
    }
  };

  const stopRemindTimer = () => {
    setUseCheckReminder(false);
  };

  //Task Count (현재 로그인한 유저에 Assign된 Pending Task 수)
    const refreshReminderCount = async () => {
    if (!userIdRef.current) return;
    const tasks = await apiRef.current.countPendingTask(userIdRef.current);
    setReminderCount(tasks);
  };



  return (
    <ReminderContext.Provider value={{ reminderStatus, refreshReminderStatus, stopRemindTimer, reminderCount, refreshReminderCount }}>
      {children}
    </ReminderContext.Provider>
  );
};

export const useReminderContext = () => {
  const context = useContext(ReminderContext);
  if (!context) throw new Error("useReminderContext must be used within ReminderProvider");
  return context;
};